import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { ListaPreciosVentaTipo } from '../../models/ListaPreciosVentaTipo';
import { ListaPreciosVentaConfiguracion } from '../../models/ListaPreciosVentaConfiguracion';
import { CompaniaConfiguracion } from '../../models/CompaniaConfiguracion';

import { generalService } from '../../services/general.service';

import { DatosGeneralesSAE } from '../../datos-generales-SAE';

@Component({
  selector: 'my-compania-configuracion',
  templateUrl: './compania-configuracion.component.html',
  styleUrls: ['./compania-configuracion.component.scss'],
  providers: [generalService]
})
export class CompaniaConfiguracionComponent implements OnInit {
	
	// ----------------------------------- DECLARACIÓN DE VARIABLES -----------------------------------

	// ------------------------ GENERALES -----------------------
	public userData: any = JSON.parse(sessionStorage.getItem('user'));
	public datosGeneralesSAE: any;
	public COMPANY_ID: string;

	// -------------------- LISTA DE PRECIOS --------------------
	public listaPreciosDisponibles: ListaPreciosVentaTipo[] = [];
	public listaPreciosUtilizados: ListaPreciosVentaConfiguracion[] = [];

	public pasarADisponibles: any = false;
	public pasarAUtilizados: any = false;

	// ----------------------------------- DECLARACIÓN DE FUNCIONES -----------------------------------
  	constructor(private _generalService: generalService,private router: Router, private route: ActivatedRoute) { 
  		this.COMPANY_ID = this.route.snapshot.paramMap.get('id');
  		this.datosGeneralesSAE = DatosGeneralesSAE;
  		
  		this.cargarPantalla();
  	}

	ngOnInit() {
		
	}

	// ------------------------ GENERALES -----------------------
	cargarPantalla(){
		this.datosGeneralesSAE.showSpinnerLoading = true;

		this.listaPreciosDisponibles = [];
        this.listaPreciosUtilizados = [];

		this._generalService.requestGet("compania/consultarConfiguracionActual?idCompania=" + this.COMPANY_ID).subscribe(
			result => {
				var dataTemp: any = JSON.parse(result);

				for(var i = 0; i < dataTemp.Table.length; i++){
					this.listaPreciosDisponibles.push({
						SALES_PRICE_LIST_TYPE_ID: dataTemp.Table[i].SALES_PRICE_LIST_TYPE_ID,
						NAME: dataTemp.Table[i].NAME,
						visible: dataTemp.Table[i].visible == 1 ? true : false,
						seleccionado: false
					});
				}

				for(var i = 0; i < dataTemp.Table1.length; i++){
					this.listaPreciosUtilizados.push({
						SALES_PRICE_LIST_SETTING_ID: dataTemp.Table1[i].SALES_PRICE_LIST_SETTING_ID,
						COMPANY_ID: dataTemp.Table1[i].COMPANY_ID,
						SALES_PRICE_LIST_TYPE_ID: dataTemp.Table1[i].SALES_PRICE_LIST_TYPE_ID,
						ORDER_LIST: dataTemp.Table1[i].ORDER_LIST,
						NAME: dataTemp.Table1[i].NAME,
						seleccionado: false
					});
				}

				this.datosGeneralesSAE.showSpinnerLoading = false;
			},
			error => {
				var errorMsj = <any>error;
				console.log(errorMsj);
			}
		);
	}

	guardarConfiguracion(){
		this.datosGeneralesSAE.showSpinnerLoading = true;

		var params: CompaniaConfiguracion = new CompaniaConfiguracion();
		params.idCompania = this.COMPANY_ID;
		params.listaPrecios = this.listaPreciosUtilizados;

		this._generalService.requestPostParams(params, "compania/guardarConfiguracion/").subscribe(
	        result => {
	        	this.datosGeneralesSAE.showSpinnerLoading = false;
	        	this._generalService.toastCall("Configuracion guardada exitosamente!");
	        	this.router.navigateByUrl('app/compania');
	        },
	        error => {
	          var errorMsj = <any>error;
	          console.log(errorMsj);
	        }
        );
	}

	regresar(){
		this.router.navigateByUrl('app/compania');
	}

	// -------------------- LISTA DE PRECIOS --------------------
	seleccionarTipoPrecio(id: any, opc: any) {
		this.pasarAUtilizados = false;
		this.pasarADisponibles = false;

		if(opc == 1){
			for(var i = 0; i < this.listaPreciosDisponibles.length; i++){
				if(this.listaPreciosDisponibles[i].SALES_PRICE_LIST_TYPE_ID == id){
					if(this.listaPreciosDisponibles[i].seleccionado){
						this.listaPreciosDisponibles[i].seleccionado = false;
					}
					else{
						this.listaPreciosDisponibles[i].seleccionado = true;
						this.pasarAUtilizados = true;
					}
				}
				else{
					this.listaPreciosDisponibles[i].seleccionado = false;
				}
			}
			for(var i = 0; i < this.listaPreciosUtilizados.length; i++){
				this.listaPreciosUtilizados[i].seleccionado = false;
			}
		}

		if(opc == 2){
			for(var i = 0; i < this.listaPreciosDisponibles.length; i++){
				this.listaPreciosDisponibles[i].seleccionado = false;
			}
			for(var i = 0; i < this.listaPreciosUtilizados.length; i++){
				if(this.listaPreciosUtilizados[i].SALES_PRICE_LIST_TYPE_ID == id){
					if(this.listaPreciosUtilizados[i].seleccionado){
						this.listaPreciosUtilizados[i].seleccionado = false;
					}
					else{
						this.listaPreciosUtilizados[i].seleccionado = true;
						this.pasarADisponibles = true;
					}
				}
				else{
					this.listaPreciosUtilizados[i].seleccionado = false;
				}
			}
		}
	}

	pasarTipoPrecio(opc: any) {
		if(opc == 1){

			for(var i = 0; i < this.listaPreciosDisponibles.length; i++){
				if(this.listaPreciosDisponibles[i].seleccionado){
					// Se quita la selección, se desactiva de precios disponibles, se pasa a precios utilizados y se quita la función del botón de pasar a utilizados
					this.listaPreciosDisponibles[i].seleccionado = false;
					this.listaPreciosDisponibles[i].visible = false;

					this.listaPreciosUtilizados.push({
						SALES_PRICE_LIST_SETTING_ID: null,
						COMPANY_ID: null,
						SALES_PRICE_LIST_TYPE_ID: this.listaPreciosDisponibles[i].SALES_PRICE_LIST_TYPE_ID,
						ORDER_LIST: (this.listaPreciosUtilizados.length + 1),

						NAME: this.listaPreciosDisponibles[i].NAME,
						seleccionado: false
					});
					this.pasarAUtilizados = false;
				}
			}

		}

		if(opc == 2){

			for(var i = 0; i < this.listaPreciosUtilizados.length; i++){
				if(this.listaPreciosUtilizados[i].seleccionado){
					// Se activa en precios disponibles, se quita de precios utilizados y se quita la función del botón de pasar a disponibles
					for(var j = 0; j < this.listaPreciosDisponibles.length; j++){
						if(this.listaPreciosDisponibles[j].SALES_PRICE_LIST_TYPE_ID == this.listaPreciosUtilizados[i].SALES_PRICE_LIST_TYPE_ID){
							this.listaPreciosDisponibles[j].visible = true;
						}
					}
					this.listaPreciosUtilizados.splice(i, 1);
					this.pasarADisponibles = false;
					i = this.listaPreciosUtilizados.length
				}
			}

			// Se actualiza el orden de la configuración de los tipos de precios
			for(var i = 0; i < this.listaPreciosUtilizados.length; i++){
				this.listaPreciosUtilizados[i].ORDER_LIST = (i + 1);
			}

		}
	}

}




// WEBPACK FOOTER //
// ./src/app/compania/configuracion/compania-configuracion.component.ts